/**
 * Route for `invoice-number-sequence-customization`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { InvoiceNumberSequenceCustomizationPage } from "../features/invoice-number-sequence-customization/InvoiceNumberSequenceCustomizationPage";

export const invoiceNumberSequenceCustomizationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/invoice-number-sequence-customization",
	component: InvoiceNumberSequenceCustomizationPage,
});

export default invoiceNumberSequenceCustomizationRoute;
